import { createContext } from "react";
import type { Status } from "types/Status";

const WellnessMetadataStatusContext = createContext<Status | undefined>(undefined);
WellnessMetadataStatusContext.displayName = "WellnessMetadataStatusContext";

export default WellnessMetadataStatusContext;
